import { cibFlask } from "@coreui/icons";

export const Values = {
    //serverIp: 'http://192.168.110.110:1010/',
    //serverIp: 'http://80.191.223.240:1010/',
    //serverIp: 'http://192.168.71.189:1021/',
    //serverIp: 'http://192.168.71.189:1022/',
    //serverIp: 'http://192.168.71.186:1021/',
    //serverIp: 'http://80.191.223.245:1021/',
    //serverIp: 'http://192.168.0.11:1021/',
    //serverIp: 'http://192.168.110.110:1011/',
    //serverIp: 'http://194.5.188.164:1021/',
    //serverIp: 'http://130.185.73.237:1021/',
    //serverIp: 'http://172.20.20.246:1010/',
    //serverIp: 'http://'+window.location.hostname+':1011/',    //back acecr
    //reportLinkIp:'http://'+window.location.hostname+':1050',  //ui port acecr
    //serverIp2: 'http://172.20.20.246:1010//',

    mapServerIp:'http://172.20.20.246:7000/styles/klokantech-basic/{z}/{x}/{y}.png',
    serverIp: 'http://'+window.location.hostname+':1021/',     //back
    reportLinkIp:'http://'+window.location.hostname+':1020',  //ui port

    companyName:"گروه فنی و مهندسی رادین آروند آریو",
    //companyName:"شهرداری زنجان",
    //companyName:"مرکز خدمات تخصصی ICT جهاد دانشگاهی واحد زنجان",
    //reportLinkIp:'http://'+window.location.hostname+':1030',  //ui port jahad
    
    tileProviders: [
        {
          name: "OpenStreetMap",
          visible: true,
          // attribution:
          //   '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          // url: "http://192.168.71.189:1010/map/iran/{z}/{x}/{y}.png",
        },
        {
          name: "OfflineMap",
          visible: false,
          url: "http://192.168.0.82:1021/map/iran/{z}/{x}/{y}.png",
          //url: 'http://172.20.20.246:7000/styles/klokantech-basic/{z}/{x}/{y}.png',
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "OpenTopoMap",
          visible: false,
          url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleRoadmap",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleTerrain",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleAlteredRoadmap",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
        {
          name: "GoogleSatellite",
          visible: false,
          url: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
          // attribution:
          //   'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        },
      ],

     
};

